import React, {Component} from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import ProjectFeeRateListItem from "./ProjectFeeRateListItem";

class ProjectFeeRatesList extends Component {

    render() {

        const {rates, project_id} = this.props

        return (
            <div className="d-flex flex-column">
                {
                    rates.map((rate, index) => <ProjectFeeRateListItem key={index} project_id={project_id} {...rate}/>)
                }
            </div>
        )
    }
}

ProjectFeeRatesList.propTypes = {
    project_id: PropTypes.string.isRequired,
    rates: PropTypes.array
}

export default ProjectFeeRatesList